import type {
  APIConnector,
  AutocompleteQueryConfig,
  AutocompleteResponseState,
  QueryConfig,
  RequestState,
  ResponseState,
} from '@elastic/search-ui'
import { searchResultsData } from 'common/components/entities/search-results/utils'
import { toResponseState } from 'src/shared/entities/search/utils'
import { v4 as uuid } from 'uuid'
export class SearchMockConnector implements APIConnector {
  async onSearch(
    state: RequestState,
    queryConfig: QueryConfig,
  ): Promise<ResponseState> {
    const { searchTerm = '', current } = state

    return toResponseState(
      {
        data: searchResultsData(3),
        total: 3,
        page: 1,
      },
      {
        searchTerm,
        currentPage: current ?? 1,
        resultsPerPage: 3,
      },
    )
  }

  async onAutocomplete(
    state: RequestState,
    queryConfig: AutocompleteQueryConfig,
  ): Promise<AutocompleteResponseState> {
    return {
      autocompletedResults: [
        {
          data: searchResultsData(3),
          total: 4,
        },
      ],
      autocompletedResultsRequestId: uuid(),
      autocompletedSuggestions: {},
      autocompletedSuggestionsRequestId: uuid(),
    }
  }

  onResultClick(params: any): void {
    //
  }

  onAutocompleteResultClick(params: any): void {
    //
  }
}
